import * as React from "react";
import {BaseFormViewState, default as BaseFormView} from "../../../../ui/form/BaseFormView";
import FormButtonsView from "../../../../ui/form/FormButtonsView";
import BrandFormBody from "../../BrandFormBody";
import BrandForm from "../../../../brand/dto/BrandForm";
import Brand from "../../../../../model/brand/Brand";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import SectionView from "../../../../layout/section/SectionView";
import Address from "../../../../../model/address/Address";
import {Option} from "ts-option";
import {DealerPriceMatrixState} from "../../../../brand/dto/DealerPriceMatrixState";
import Site from "../../../../../model/site/Site";
import ButtonGroupWrapper from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonGroupWrapper";
import BrandJobTypeUtilitiesModal from "../../modal/BrandJobTypeUtilitiesModal";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {Brand} new brand object.
	 * @param {Option<Address>} selected address for brand.
	 */
	onSubmit: (brand: Brand, address: Option<Address>) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Brand to edit.
	 */
	brand: Brand;
	/**
	 * Address to prepopulate address field.
	 */
	address: Option<Site>
	/**
	 * On add file
	 */
	onAddFile: (file: File) => any
	/**
	 * On remove file
	 */
	onRemoveFile: () => any
}

type IState = BaseFormViewState<BrandForm> & {
	showJobTypeUtilitiesModal: boolean;
};

export default class EditBrandFormView extends BaseFormView<BrandForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: BrandForm.createFromBrand(this.props.brand, props.address.map(a => a.data.address)),
			isFormDirty: false,
			shouldValidate: false,
			showJobTypeUtilitiesModal: false
		};
		this.onDealerPriceMatrixChange = this.onDealerPriceMatrixChange.bind(this);
		this.onCreditAmountMatrixChange = this.onCreditAmountMatrixChange.bind(this);
	}

	onDealerPriceMatrixChange(dealerPriceMatrix: DealerPriceMatrixState) {
		this.setState({form: this.state.form.copy({dealerPriceMatrix})});
	}

	onCreditAmountMatrixChange(creditAmountMatrix: DealerPriceMatrixState) {
		this.setState({form: this.state.form.copy({creditAmountMatrix})});
	}

	render() {
		return (
			<SectionView>
				<BrandFormBody form={this.state.form}
							   onFieldChange={this.onFieldChanged}
							   onFieldCompleted={this.onFieldCompleted}
							   onFocusChange={this.onFocusChange}
							   onFieldsChange={this.onFieldsChanged}
							   onDealerPriceMatrixChange={this.onDealerPriceMatrixChange}
						   onCreditAmountMatrixChange={this.onCreditAmountMatrixChange}
							   {...this.props}/>
				<ButtonGroupWrapper>
					<ButtonPrimary onClick={() => this.setState({showJobTypeUtilitiesModal: true})}
								   label={"Job types configuration"}
								   disabled={this.props.isSubmitting}/>
				</ButtonGroupWrapper>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Update brand"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
				{this.state.showJobTypeUtilitiesModal &&
				<BrandJobTypeUtilitiesModal brandId={this.props.brand.id}
										   onFinish={() => this.setState({showJobTypeUtilitiesModal: false})}/>}
			</SectionView>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(brand => this.props.onSubmit(brand, this.state.form.address.getOptionalValue()), () => {});
		});
	}
}
